import React, { Component } from "react";
import Breadcrumb from "./breadcrumb";
import { Button } from "react-bootstrap";
import { getSettings, updateSettings } from "../../../services/clinicPortalServices/settingService";
import { FormGroup, FormControlLabel, Switch, TextField, MenuItem } from "@mui/material";
import toastr from "toastr";
import { specimenTypes } from "../../../services/common/optionsData";
import { getAllTests } from "../../../services/clinicPortalServices/testService";

class ClinicConfigurationss extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: [],
            is_show_diagnosis_code_for_tests_create_requisition: false,
            is_show_diagnosis_code_for_medications_create_requisition: false,
            is_show_collector_name_create_requisition: false,
            default_specimen_type: "",
            default_test: "",
            tests: []
        };
    }

    componentDidMount() {
        getSettings().then((response) => {
            if (response && response.data) {
                this.setState({
                    is_show_diagnosis_code_for_tests_create_requisition:
                        response.data.is_show_diagnosis_code_for_tests_create_requisition,
                    is_show_diagnosis_code_for_medications_create_requisition:
                        response.data.is_show_diagnosis_code_for_medications_create_requisition,
                    is_show_collector_name_create_requisition: response.data.is_show_collector_name_create_requisition,
                    default_specimen_type: response.data.default_specimen_type,
                    default_test: response.data.default_test
                });
            }
        });

        getAllTests({ type: "all" }).then((res) => {
            this.setState({ tests: res.data });
        });
    }

    handleSwitchChange = (e) => {
        let info = {
            [e.target.name]: e.target.checked
        };
        updateSettings(info).then((response) => {
            if (response.status === 200) {
                toastr.success(response.message);
            }
        });
        this.setState({ [e.target.name]: e.target.checked });
    };

    handleChange = (e) => {
        const info = {
            [e.target.name]: e.target.value
        };
        updateSettings(info).then((response) => {
            if (response.status === 200) {
                toastr.success(response.message);
            }
        });
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    render() {
        return (
            <div className="clinic-contain">
                <Breadcrumb />
                <div className="px-5 py-3">
                    <div className="row">
                        <div className="col-12 col-md-6 d-flex flex-column mt-3">
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            onChange={this.handleSwitchChange}
                                            checked={this.state.is_show_diagnosis_code_for_tests_create_requisition}
                                            name="is_show_diagnosis_code_for_tests_create_requisition"
                                        />
                                    }
                                    label="Show Diagnosis Code for Tests when Create Requisition"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            onChange={this.handleSwitchChange}
                                            checked={
                                                this.state.is_show_diagnosis_code_for_medications_create_requisition
                                            }
                                            name="is_show_diagnosis_code_for_medications_create_requisition"
                                        />
                                    }
                                    label="Show Diagnosis Code for Medications when Create Requisition"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            onChange={this.handleSwitchChange}
                                            checked={this.state.is_show_collector_name_create_requisition}
                                            name="is_show_collector_name_create_requisition"
                                        />
                                    }
                                    label="Show Name of Collector when Create Requisition"
                                />
                            </FormGroup>
                        </div>
                        <div className="col-12 col-md-6 mt-3">
                            <div>
                                <div className="form-group">
                                    <label className="mb-3">Default Specimen Type</label>
                                    <TextField
                                        select
                                        label="Specimen Type"
                                        name="default_specimen_type"
                                        value={this.state.default_specimen_type}
                                        onChange={this.handleChange}
                                    >
                                        {specimenTypes.map((specimenType) => {
                                            return (
                                                <MenuItem value={specimenType} key={specimenType}>
                                                    {specimenType}
                                                </MenuItem>
                                            );
                                        })}
                                    </TextField>
                                </div>
                            </div>
                            <div>
                                <div className="form-group">
                                    <label className="mb-3">Default Test</label>
                                    <TextField
                                        select
                                        label="Default Test"
                                        name="default_test"
                                        value={this.state.default_test}
                                        onChange={this.handleChange}
                                    >
                                        {this.state.tests.map((test) => {
                                            return (
                                                <MenuItem value={test._id} key={test._id}>
                                                    {test.name}
                                                </MenuItem>
                                            );
                                        })}
                                    </TextField>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ClinicConfigurationss;
